import React from "react";
import {
  Select,
  // Input,
  MenuItem,
  Checkbox,
  Chip,
  FormControlLabel,
  // IconButton,
  makeStyles,
  FormControl
} from "@material-ui/core";
import clsx from "clsx";
import { CloseOutlined } from "@material-ui/icons";
import { MenuPropsForTableFilter } from "../../helpers/menuProps";
// import { handleItemsSelected } from "../../helpers/handleMultipleSelection";
import { Scrollbars } from "react-custom-scrollbars";
import { NoDataText, DefaultMenuItem } from "../commons/StyledTexts";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(2),
    height: 35,
    padding: "7.5px 50px 7.5px 14px",
    verticalAlign: "middle",

    "& .MuiChip-root": {
      backgroundColor: "#e0e0e094 !important",
      marginRight: "5px !important",
      height: "auto",
      borderRadius: 4,
      fontSize: 12
    },

    "& .MuiOutlinedInput-input > div > div::-webkit-scrollbar": {
      display: "none"
    },

    "&:hover .m-select-close": {
      visibility: "visible"
    }
  },
  noEmpty: {
    padding: 0,
    minWidth: 100,

    "& .default-value": {
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)"
    }
  },
  small: {
    "& .MuiOutlinedInput-input": {
      paddingTop: 7.5,
      paddingBottom: 7.5,
      paddingRight: 50,
      minHeight: "auto"
    }
  },
  select: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%"
  },
  close: {
    position: "absolute",
    // right: 7,
    // top: -3,
    right: 26,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    fontSize: 16,
    cursor: "pointer",
    visibility: "hidden",
    zIndex: 10,

    "&:hover": {
      color: "#444"
    }
  }
}));

const MultipleSelector = props => {
  const {
    name,
    options = [],
    value = [],
    onChange,
    onClick,
    disabled,
    readOnly,
    noDropdown,
    placeholder,
    noOptionsText,
    clearable = true,
    variant = "outlined",
    size = "small",
    height = 20,
    className,
    style,
    multiple= true
  } = props;

  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      position: "relative",
      top: "17px",
      height: "3px",
      borderRadius: "1px"
    };
    return <div className="track" style={{ ...trackStyle }} {...props} />;
  };

  const hasOptions = options.length > 0;
  const showDefaultText = !value || value.length < 1;
  const classes = useStyles();

  // const onDelete = (e, value) => {
  //   e.stopPropagation();
  //   onChange?.(options.filter(item => item.id !== value));
  // };

  return (
    <FormControl
      className={clsx(
        classes.root,
        size === "small" && classes.small,
        !showDefaultText && classes.noEmpty,
        className
      )}
      style={style}
      onClick={onClick}
    >
      <DefaultMenuItem text={placeholder} ifShow={showDefaultText} />
      {/* <DefaultMenuItem text={noOptionsText} ifShow={!hasOptions} /> */}
      {clearable && !disabled && !readOnly && !showDefaultText && (
        // <IconButton
        //   className={classes.close}
        //   onClick={e => {
        //     e.stopPropagation();
        //     onChange?.({ target: { name, value: [] } });
        //   }}
        // >
        <CloseOutlined
          fontSize="small"
          color="inherit"
          className={clsx("m-select-close", classes.close)}
          onClick={e => {
            e.stopPropagation();
            onChange?.({ target: { name, value: [] } });
          }}
        />
        // </IconButton>
      )}
      <Select
        className={showDefaultText ? classes.select : ""}
        variant={variant}
        name={name}
        multiple={multiple}
        value={value}
        fullWidth
        displayEmpty
        disabled={disabled}
        readOnly={readOnly || noDropdown}
        // input={<Input fullWidth={true} variant="outlined" />}
        renderValue={array => {
          if (!array || !array.length) {
            return null;
          }
          return (
            <Scrollbars
              thumbMinSize={10}
              style={{ height }}
              renderTrackHorizontal={renderTrack}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
            >
              {options
                .filter(option => array.includes(option.id))
                .map(o => (
                  <Chip
                    key={o.id}
                    label={o.name}
                    deleteIcon={<CloseOutlined />}
                    // onDelete={e => onDelete(e, o.id)}
                  />
                ))}
            </Scrollbars>
          );
        }}
        MenuProps={MenuPropsForTableFilter}
      >
        {hasOptions ? (
          options.map(o => {
            return (
              <MenuItem key={o.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value && value.includes(o.id)}
                      id={o.id}
                      onChange={e => {
                        if (e.target.checked) {
                          onChange({
                            target: { name, value: [...value, o.id] }
                          });
                        } else {
                          onChange({
                            target: {
                              name,
                              value: value && value.filter(item => item !== o.id)
                            }
                          });
                        }
                      }}
                      name={o.name}
                    />
                  }
                  label={o.name}
                />
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={false} disabled>
            <NoDataText text={noOptionsText} />
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MultipleSelector;
